import { Theme } from '@mui/material/styles';

// ==============================|| CUSTOM FUNCTION - COLORS ||============================== //

type ColorType = 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';

interface ColorObject {
  lighter: string;
  light: string;
  main: string;
  dark: string;
  darker?: string;
  contrastText: string;
  [key: number]: string;
}

export default function getColors(theme: Theme, color: ColorType | string): ColorObject {
  switch (color) {
    case 'secondary':
      return theme.palette.secondary as any;
    case 'error':
      return theme.palette.error as any;
    case 'warning':
      return theme.palette.warning as any;
    case 'info':
      return theme.palette.info as any;
    case 'success':
      return theme.palette.success as any;
    default:
      return theme.palette.primary as any;
  }
}

